<template>
  <div>
  </div>
</template>

<script>
import router from '@/router'
import { resolveStartPage } from '@/use/useStartPage'

export default {
  async beforeMount () {
    const startPage = resolveStartPage({
      canSeeGames: this.$store.getters.isAdminOrInternalScorekeeper,
      isMediaManager: this.$store.getters.isMediaManager
    })

    if (startPage) {
      await router.push({
        name: startPage.name,
        params: { clientId: this.currentClient.uuid },
        query: startPage.query
      })
    } else {
      await router.push({
        name: 'enterTheGame',
        params: { clientId: this.currentClient.uuid }
      })
    }
  },
  computed: {
    currentClient () {
      return this.$store.state.currentClient
    }
  }
}
</script>
